var shvenergy = shvenergy || {};

shvenergy.error = (function ($) {
    "use strict";

    function setHeader(header) {
        $(".js-error-h1").text(header.h1);
        $(".js-error-h21").text(header.h21);
        $(".js-error-h22").text(header.h22);
    }

    function setImages(image) {
        $(".js-error-logo").attr("src", image);
        $(".js-error-logo").attr("src", image);
    }

    function setText(text) {
        $(".js-error-text").html(text);
    }

    function setSocial(social) {
        $(".js-error-header1").text(social.header);
        var links = $(".js-social-link");
        links.empty();

        for (var i = 0; i < social.links.length; i++) {
            links.append("<a class='error500__link' href=' " + social.links[i].url + "'>" + social.links[i].title + "</a>");
        }
    }

    function setContact(contact) {
        $(".js-error-header2").text(contact.title);
        $(".js-error-phone").attr("href", "tel:" + contact.phone).text(contact.phone);
        if (contact.mail) {
            $(".js-error-mail").attr("href", "mailto:" + contact.mail).text(contact.mail);
        } else {
            $(".js-error-mail").remove();
        }

    }

    function getCulture() {
        var indexOfHost = location.href.indexOf(location.host);
        var relativePath = location.href.substring(indexOfHost + location.host.length);
        var pathRegex = /\/(\w{2}(?:-\w{2})?)\//i;
        var pathMatches = pathRegex.exec(relativePath);
        if (pathMatches && pathMatches.length > 1) {
            console.log(pathMatches[1]);
            return pathMatches[1];
        }

        if (shvenergy.cookies.hasCookieCategoryConsent("_shvenergy_custom_lang")) {
            var cookieRegex = /_shvenergy_custom_lang=(\w{2}(?:-\w{2})?)/i;
            var cookies = document.cookie;
            var matches = cookieRegex.exec(cookies);
            if (matches && matches.length > 1) {
                console.log(matches[1]);
                return matches[1].toLowerCase();
            }
        }

        return navigator.language.toLowerCase();
    }

    // Write a selector for different content files here!
    function getContentUrl() {
        var culture = getCulture();
        console.log("Current culture:", culture);

        if (location.host.indexOf("shvenergy93") !== -1) {
            if (culture === "en" || culture === "en-gb") {
                return "/errors/shvenergy.en.json";
            }
            else {
                return "/errors/shvenergy.fr-fr.json";
            }
        }
        else if (location.host.indexOf("shvmaster") !== -1) {
            if (culture === "en") {
                return "/errors/shvenergy.en.json";
            } else {
                return "/errors/shvenergy.fr-fr.json";
            }
        }
        else if (location.host.indexOf("shvenergy.com") !== -1 || location.host.indexOf("shvenergycom") !== -1) {
            return "/errors/shvenergy.en.json";
        }
        else if (location.host.indexOf("primagaz.fr") !== -1 || location.host.indexOf("primagazfr") !== -1) {
            return "/errors/shvenergy.fr-fr.json";
        }
        else if (location.host.indexOf("calor.co.uk") !== -1 || location.host.indexOf("calorcouk") !== -1) {
            return "/errors/calor.en-gb.json";
        }
        else if (location.host.indexOf("ipragaz.tr") !== -1 || location.host.indexOf("ipragaztr") !== -1) {
            return "/errors/ipragaz.tr.json";
        }
        else if (location.host.indexOf("calorgas.ie") !== -1 || location.host.indexOf("calorgasie") !== -1) {
            return "/errors/calorgas.en-ie.json";
        }
        else if (location.host.indexOf("primagas.de") !== -1 || location.host.indexOf("primagasde") !== -1) {
            return "/errors/primagas.de-de.json";
        }
        else if (location.host.indexOf("primagas.es") !== -1 || location.host.indexOf("primagases") !== -1) {
            return "/errors/primagas.es.json";
        }      
        else if (location.host.indexOf("primagaz.lu") !== -1 || location.host.indexOf("primagazlu") !== -1) {
            return "/errors/primagaz.lu.json";
        }
        else if (location.host.indexOf("primagaz.be") !== -1 || location.host.indexOf("primagazbe") !== -1) {
            if (culture === "fr-be") {
                return "/errors/primagaz.be-fr.json";
            }
            else {
                return "/errors/primagaz.be-nl.json";
            }
        }
        else if (location.host.indexOf("primagaz.dk") !== -1 || location.host.indexOf("primagazdk") !== -1) {
            return "/errors/primagaz.dk.json";
        }
        else if (location.host.indexOf("primagaz.se") !== -1 || location.host.indexOf("primagazse") !== -1) {
            return "/errors/primagaz.se.json";
        }
        else if (location.host.indexOf("primagaz.no") !== -1 || location.host.indexOf("primagazno") !== -1) {
            return "/errors/primagaz.no.json";
        }
        else if (location.host.indexOf("gaspol.pl") !== -1 || location.host.indexOf("gaspolpl") !== -1) {
            return "/errors/gaspol.pl.json";
        }
        else if (location.host.indexOf("pinnaclepropane.com") !== -1 || location.host.indexOf("pinnaclecom") !== -1) {
            return "/errors/pinnacle.com.json";
        }
        else if (location.host.indexOf("supergas.com") !== -1 || location.host.indexOf("supergascom") !== -1) {
            return "/errors/supergas.com.json";
        }
        else if (location.host.indexOf("liquigas.it") !== -1 || location.host.indexOf("liquigasit") !== -1) {
            return "/errors/liquigas.it.json";
        }
        else if (location.host.indexOf("supergasbras.com.br") !== -1 || location.host.indexOf("supergasbrascombr") !== -1) {
            return "/errors/supergasbras.br-pt.json";
        }
        else if (location.host.indexOf("alliantgas.com") !== -1 || location.host.indexOf("alliantgascom") !== -1) {
            return "/errors/alliantgas.com.json";
        }
        else if (location.host.indexOf("primagas.cz") !== -1 || location.host.indexOf("primagascz") !== -1) {
            return "/errors/primagas.cz.json";
        }
        else if (location.host.indexOf("butanplin.si") !== -1 || location.host.indexOf("butanplinsi") !== -1) {
            return "/errors/butanplin.si.json";
        }
        else if (location.host.indexOf("futuriafuels.com") !== -1 || location.host.indexOf("futuria") !== -1) {
            return "/errors/futuria.json";
        } 
        else if (location.host.indexOf("butanplin.hr") !== -1 || location.host.indexOf("butanplinhr") !== -1) {
            return "/errors/butanplin.hr.json";
        }
        else if (location.host.indexOf("sunsource-energy.com") !== -1 || location.host.indexOf("sunsource") !== -1) {
            return "/errors/sunsourceenergy.com.json";
        }
        else if (location.host.indexOf("petromaxlpg.com") !== -1 || location.host.indexOf("petromax") !== -1) {
            return "/errors/petromax.com.json";
        }
    }

    function setSiteColour(Colour) {
        $(".error500__default").css("background-color", Colour);
    }

    function init() {
        var contentUrl = getContentUrl();
        $.getJSON(contentUrl, function (data) {
            var siteContent = data.shvenergy;
            setHeader(siteContent.header);
            setImages(siteContent.image);
            setText(siteContent.text);
            setSocial(siteContent.social);
            setContact(siteContent.contact);
            setSiteColour(siteContent.bc);
        });
    }

    init();

})(jQuery);